import { Instance } from 'mobx-state-tree';
import { BulkUpdateVisitsResultDtoModelBase } from './BulkUpdateVisitsResultDtoModel.base';

/* The TypeScript type of an instance of BulkUpdateVisitsResultDtoModel */
export interface BulkUpdateVisitsResultDtoModelType extends Instance<typeof BulkUpdateVisitsResultDtoModel.Type> {}

/* A graphql query fragment builders for BulkUpdateVisitsResultDtoModel */
export { selectFromBulkUpdateVisitsResultDto, bulkUpdateVisitsResultDtoModelPrimitives, BulkUpdateVisitsResultDtoModelSelector } from './BulkUpdateVisitsResultDtoModel.base';

/**
 * BulkUpdateVisitsResultDtoModel
 */
export const BulkUpdateVisitsResultDtoModel = BulkUpdateVisitsResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
